// Only a non-sensitive boolean is retained per tab; never store financial fields or IDs.
import { guardLegacyReplay } from './legacyReplayPrivacy';
if (typeof window !== 'undefined') window.__ucwStopLegacyReplay = guardLegacyReplay;
export const TELEMETRY_PRIVACY_KEY = 'ucw-telemetry-private-v1';
const privateTab = () => { try { return sessionStorage.getItem(TELEMETRY_PRIVACY_KEY) === '1'; } catch { return true; } };
const privatePath = path => /^\/(hosts|worker|after-stay|login|register)(\/|$)/.test(path) || /^\/(ucw-sys-|sys-)/.test(path);
export const privateTelemetryUrl = value => {
  try {
    const url = new URL(value || window.location.href, window.location.origin);
    return privatePath(url.pathname)
      || /\/api\/admin(?:\/|$)/.test(url.pathname)
      || /\/api\/(hosts|worker|guest\/(mod05|mod06)|mod06)/.test(url.pathname)
      || privatePath(url.searchParams.get('redirect') || '');
  } catch { return true; }
};
export const enterPrivateTelemetry = () => {
  guardLegacyReplay();
  if (window.__ucwEnterPrivateTelemetry) return window.__ucwEnterPrivateTelemetry();
  window.__ucwPrivateTelemetry = true;
  try { sessionStorage.setItem(TELEMETRY_PRIVACY_KEY, '1'); } catch { /* remain private in memory */ }
  const id = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (id) window[`ga-disable-${id}`] = true;
};
export const telemetryIsPrivate = () => {
  if (window.__ucwPrivateTelemetry || privateTab()) { enterPrivateTelemetry(); return true; }
  if (privateTelemetryUrl(window.location.href)) { enterPrivateTelemetry(); return true; }
  return false;
};

export const containsPrivateTelemetry = value => {
  const seen = new WeakSet();
  let visited = 0;
  const scan = item => {
    if (++visited > 10000) return true; // Unknown oversized payloads fail closed.
    if (typeof item === 'string') {
      let text = item.replace(/\\\//g, '/');
      try { text = decodeURIComponent(text); } catch { /* scan the original text */ }
      return /\/(?:hosts|worker|after-stay|login|register)(?:[/?#\s"']|$)/i.test(text)
        || /\/(?:ucw-sys-|sys-)/i.test(text) || /\/api\/admin(?:[/?#\s"']|$)/i.test(text)
        || /\/api\/[^\s"']*(?:mod01|mod02|mod03|mod05|mod06|mod07|mod08|mod09|mod10|mod11)/i.test(text);
    }
    if (!item || typeof item !== 'object') return false;
    // No attachments/replay are needed for public telemetry. Unknown binary data is withheld.
    if (ArrayBuffer.isView(item) || item instanceof ArrayBuffer) return true;
    if (seen.has(item)) return false;
    seen.add(item);
    try { return Object.values(item).some(scan); } catch { return true; }
  };
  return scan(value);
};